import { createColumnHelper } from "@tanstack/react-table";
import { YearPresent } from "../../interfaces/app_types";
import { getYear } from "../funcs/common";

const columnHelper = createColumnHelper<YearPresent>();
export const yearlyAttdModalCols = [
  columnHelper.accessor((row) => row?.emp_name, {
    header: "Name",
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor((row) => row?.years.year1, {
    header: getYear(0),
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor((row) => row?.years.year2, {
    header: getYear(1),
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor((row) => row?.years.year3, {
    header: getYear(2),
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor((row) => row?.years.year4, {
    header: getYear(3),
    cell: (info) => info.getValue(),
  }),
];
